import { Map } from 'ol';
import { Attribution, defaults as defaultOLControls } from 'ol/control';
import { defaults as defaultOLInteractions } from 'ol/interaction';

export const createCountryMap = (): Map => {
  const controlOptions = { attribution: false, rotate: false };
  const controlExtensions = [new Attribution({ collapsible: false })];
  const controls = defaultOLControls(controlOptions).extend(controlExtensions);
  const interactions = defaultOLInteractions({ altShiftDragRotate: false, pinchRotate: false });
  return new Map({ controls, interactions });
};
